'use strict';

// Settings configured here will be merged into the final config object.
const baseDomain = window.location.hostname.split('.').slice(-2).join('.')
const subDomain = window.location.hostname.split('.')[0]

export default {
  useFakeStream: false,
  backOfficeBasePath: '/backoffice',
  baseDomain,
  subDomain,
  newsCrop: { width: 1080, height: 670 },
  raffleCrop: { width: 1080, height: 670 },
  voting: {
    imageCrop: { width: 580, height: 440 }
  },
  player: {
    imageCrop: { width: 400, height: 400 }
  },
  participantCrop: {width: 190, height: 190 },
  streamCrop: {width: 1080, height: 670 },
  vodImgCrop: {width: 1240, height: 770 },
  fanBoxMessageCrop: { width: 1080, height: 670 },
  partnerBannerCrop: { width: 1242, height: 230 },
  clubCms: {
    imageListCrop: {width: 1080, height: 670},
    listCrop: {width: 470, height: 470},
    galleryPreview: {width: 450, height: 450}
  },
  allowedFormats: '.MPEG4'
}



// WEBPACK FOOTER //
// ./src/config/base.ts